import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.fill";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { setOpacity } from "../lib/color";
export var pressableColors = {
  black: '#000000',
  white: '#ffffff',
  blue500: '#5469d4',
  blue600: '#3d4eac',
  cyan400: '#3a97d4',
  gray50: '#f7fafc',
  gray100: '#e3e8ee',
  gray300: '#a3acb9',
  gray700: '#3c4257',
  gray900: '#1a1f36',
  orange400: '#e56f4a',
  orange500: '#c44c34',
  red500: '#cd3d64',
  red600: '#a41c4e'
};
export var defaultPressableTheme = {
  color: {
    primary: pressableColors.blue500,
    hover: pressableColors.gray900,
    default: pressableColors.gray700,
    disabled: pressableColors.gray300,
    negative: pressableColors.red500,
    onPrimary: pressableColors.white,
    onNegative: pressableColors.white
  },
  fill: {
    primary: pressableColors.blue500,
    disabled: pressableColors.gray50,
    warning: pressableColors.orange400,
    negative: pressableColors.red500,
    inset: pressableColors.gray100,
    base: pressableColors.white
  },
  keyline: {
    base: setOpacity(pressableColors.gray700, 0.16),
    primary: pressableColors.blue500,
    negative: pressableColors.red500,
    warning: pressableColors.orange500,
    focus: setOpacity(pressableColors.cyan400, 0.28)
  },
  shadow: {
    key: setOpacity(pressableColors.black, 0.12),
    ambient: setOpacity(pressableColors.gray700, 0.08),
    focus: setOpacity(pressableColors.cyan400, 0.36)
  }
};
export var mergeThemes = function mergeThemes(theme, add) {
  return {
    color: _objectSpread({}, theme.color, add.color || {}),
    fill: _objectSpread({}, theme.fill, add.fill || {}),
    keyline: _objectSpread({}, theme.keyline, add.keyline || {}),
    shadow: _objectSpread({}, theme.shadow, add.shadow || {})
  };
};
export var cloneTheme = function cloneTheme(theme) {
  return mergeThemes(theme, {});
};
export var PressableThemeContext = React.createContext(defaultPressableTheme);
export var PressableThemeProvider = function PressableThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  var parentTheme = React.useContext(PressableThemeContext);
  var value = React.useMemo(function () {
    return mergeThemes(parentTheme, theme);
  }, [parentTheme, theme]);
  return /*#__PURE__*/React.createElement(PressableThemeContext.Provider, {
    value: value
  }, children);
};